export const roles = {
  ROLE_ADMIN: 'admin',
  ROLE_SUPER_USER: 'super_user',
  ROLE_SCREENER: 'screener',
  ROLE_OFFICE: 'office',
}
